<template>
  <div class="sidebar-pane">
    <!-- Static Navigation Links -->
    <ul class="nav nav-stacked nav-sidebar-links pipeline-static-nav pb-2 mb-2">
      <li class="nav-item">
        <router-link
          to="/dashboard"
          class="nav-link"
          data-testid="investigations-dashboard"
        >
          <span class="nav-link-name clip-text align-middle ml-1">Dashboard</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/investigations"
          class="nav-link"
          data-testid="investigations-list"
        >
          <span class="nav-link-name clip-text align-middle ml-1">Investigations</span>
        </router-link>
      </li>
    </ul>

    <!-- Investigation List with Search -->
    <SidebarInvestigationList />
  </div>
</template>

<script setup>
import SidebarInvestigationList from '@/components/sidebar/SidebarInvestigationList.vue'
</script>

<style lang="scss" scoped>
.sidebar-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}

// Static nav links styling (matches Mezmo pipeline sidebar)
.nav-sidebar-links {
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  list-style: none;

  .nav-item {
    margin: 0;
  }

  .nav-link {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    color: var(--bs-light);
    text-decoration: none;
    transition: background-color 0.2s ease;
    border-left: 3px solid transparent;

    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }

    &.router-link-active,
    &.router-link-exact-active {
      background-color: rgba(13, 110, 253, 0.1);
      border-left-color: var(--bs-primary);
      font-weight: 500;
    }
  }

  .nav-link-name {
    font-size: 0.875rem;
  }
}

.pipeline-static-nav {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
